import {Component, Input} from '@angular/core';

/**
 * A component that renders a skyline icon for several stores.
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
  selector: 'app-icon-store-multiple',
  templateUrl: './icon-store-multiple.component.html',
  styleUrls: ['./icon-store-multiple.component.scss'],
  standalone: false,
})
export class IconStoreMultipleComponent {
  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
